import {
  CursorTooltip,
  TooltipLabel,
  TooltipRow,
  TooltipTitle,
  TooltipValue,
} from "./CursorTooltip";
import type { StatusSegment } from "./StatusBreakdownChart";

// The hovered segment's breakdown, following the cursor. Used by the radar chart.
export function SegmentTooltip({
  segment,
  x,
  y,
}: {
  segment: StatusSegment;
  x: number;
  y: number;
}) {
  if (!segment.details || segment.details.length === 0) return null;
  return (
    <CursorTooltip x={x} y={y} contentKey={segment.key}>
      <TooltipTitle>{segment.label}</TooltipTitle>
      {segment.details.map((d) => (
        <TooltipRow key={d.label}>
          <TooltipLabel>{d.label}</TooltipLabel>
          <TooltipValue>{d.value}</TooltipValue>
        </TooltipRow>
      ))}
    </CursorTooltip>
  );
}
